<template>
  <div class="main">
    <tab :title="nav_name"></tab>
    <div class="top_title">
        账户信息
    </div>
    <div class="top">
      <div class="top_oli carNo">卡号：{{ item.cardNo }}</div>
      <div class="top_oli" v-if="item.cardLimit==1">单次加注限额：{{ item.perAmount }}元</div>
      <div class="top_oli" v-else>卡余额：{{ item.balance }}元</div>
      <div class="top_oli" v-if="item.carNo&&item.carNo!=''">车牌号码：{{ item.carNo }}</div>
      <div class="top_oli" v-if="item.cardLimit==1">卡余额：{{ item.balance }}元</div>
      <div class="top_oli" v-if="nav_name=='车卡操作'">持卡人：{{ item.orgName }}</div>
      <div class="top_oli" v-else>持卡人：{{ item.custName }}</div>
      <div class="top_oli">手机号码：{{ item.mobile }}</div>
      <div class="top_oli">发卡时间：{{ item.createTime }}</div>
      <div class="top_oli">
        状态：<span :class="item.status == 1 ? 'lv' : 'red'">{{
          item.status == 1 ? "启用" : "禁用"
        }}</span>
      </div>
      <div
        class="operation_btn"
        v-if="item.status == 1"
        @click="determineType(item.status, item.id)"
      >
        禁用
      </div>
      <div
        class="operation_btn"
        v-if="item.status == 0"
        @click="determineType(item.status, item.id)"
      >
        启用
      </div>
    </div>
    <div class="top_title">
        账户余额分配
    </div>
    <div class="bottom">
      <div class="bottom_title">
        可分配余额：<span>{{ balance }}</span>
      </div>
      <div class="bottom_title">
        当前子账户余额：<span>{{item.balance}}</span>
      </div>
      
      <div class="operation_input" @focusout="inputBlur" @focusin="inputFocus">
        <span>{{ inputName }}：</span
        ><input v-model="value" maxlength="7" type="number" @input="setValueModel"/>
      </div>
      <div class="choose_btn">
          <span>本次分配方式:</span>
        <div class="fenpei_btn" :id="type==0?'blue':''" @click="chooseType(0)">分配</div>
        <div class="fanfenpei_btn" :id="type==1?'blue':''" @click="chooseType(1)">反分配</div>
      </div>
      <div class="determine_btn" @click="confirm">确定</div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import tab from "@/components/NavBar";
import { Dialog } from "vant";

import { Toast } from "vant";

Vue.use(Toast);
export default {
  name: "margin",
  data() {
    return {
      inputName: "本次分配金额",
      type: 0,
      nav_name: "",
      item: "",
      balance: 0,
      value: "",
    };
  },
  components: {
    tab,
  },
  watch: {
    // value: function(val){
    //   this.value = val.replace(/\D/g, '')
    // }
  },
  mounted(options) {
    this.item = this.$route.params.item;
    this.balance = this.$storage.get("balance");
    console.log(this.$route.params.item);

    this.nav_name = this.$route.params.nav_name;
    console.log(this.nav_name)
  },
  methods: {
    setValueModel(){
      let value = this.value;
      if(value.split('').length>8){
        this.value = ''
        return
      }
      // 去除非数字和小数点的字符
      value = value.replace(/[^0-9.]/g, '');
      // 确保只有一个小数点
      const parts = value.split('.');
      if (parts.length > 2) {
        value = parts[0] + '.' + parts.slice(1).join('').slice(0, 2);
      } else if (parts.length === 2) {
        value = parts[0] + '.' + parts[1].slice(0, 2);
      }

      const regex = /^\d+(\.\d{0,2})?$/;
      if (!regex.test(value)) {
        this.errorMessage = '请输入整数或最多两位小数';
        this.value = '';
      } else {
        this.errorMessage = '';
        this.value = value;
      }
    },
    inputBlur(e) {
        if (e && e.target && e.target.tagName && e.target.tagName.toLowerCase() === 'input') {
          this.timer = setTimeout(() => {
            window.scrollTo(0, 0);
          }, 0);
        }
      },
      inputFocus(e) {
        if (e && e.target && e.target.tagName && e.target.tagName.toLowerCase() === 'input') {
          clearTimeout(this.timer);
        }
      },
    chooseType(type) {
      this.type = type;
      if (type == 0) {
        //分配
        this.inputName = "分配金额";
        return;
      }
      if (type == 1) {
        //反分配
        this.inputName = "反分配金额";
        return;
      }
    },
    confirm() {
      console.log(this.value);
      console.log(this);

      if (this.type == 0) {
        var balance = (this.item.balance - 0 + (this.value - 0)).toFixed(2);
        var zhanghubalance = (
          this.$storage.get("balance") - this.value
        ).toFixed(2);
        var text = "分配";
        if ((this.value-0)>(this.balance-0) ) {
          Toast("分配金额不能大于账户余额");
          return;
        }
      } else {
        var balance = (this.item.balance - 0 - (this.value - 0)).toFixed(2);
        var zhanghubalance = (
          this.$storage.get("balance") -
          0 +
          (this.value - 0)
        ).toFixed(2);
        if (balance < 0) {
          Toast("反分配金额不能大于卡余额");
          return;
        }
        var text = "反分配";
      }

      Dialog.confirm({
        title: "温馨提示",
        message: `${text}后卡号为${this.item.cardNo}的卡余额为${balance}，账户可分配余额为${zhanghubalance}，确认分配？`,
      })
        .then(() => {
          // on confirm

          this.assignCustCard(zhanghubalance);
        })
        .catch(() => {
          // on cancel
        });
    },
    assignCustCard(zhanghubalance) {
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      if(this.value==''){
        Toast.clear();
        Toast('请填写操作金额')
        return
      }
      var data = {
        token: this.$storage.get("token"),
        id: this.item.id,
        assignType: this.type,
        assignAmount: this.value,
      };
      if (this.nav_name == "加油卡操作") {
        var url = "orgapp/assignCustCard";
      } else {
        var url = "orgapp/assignCarCard";
      }
      this.$api.post(url, data, (response) => {
        console.log(response);
        if (response.status >= 200 && response.status < 300) {
          var data = response.data;
          if (data.msg == "success") {
            Toast.clear();
            Dialog.alert({
              title: "标题",
              message: "操作成功！",
            }).then(() => {
              // on close
              this.$storage.set("balance", zhanghubalance);
              this.$router.go(-1);
            });
          } else {
            Toast.clear();
            if (data.msg == "token失效，请重新登录") {
              this.$router.push({
                name: "login",
              });
            }else{
              Dialog.alert({
                title:'温馨提示',
                message:data.msg,
                showCancelButton:false
              })
            }
            
          }
        } else {
        }
      });
    },
    determineType(type, id) {
      if (type == 1) {
        //当前状态为启用，点击后执行停用
        //调用接口停用
        var msg = "确认禁用？";
        var status = 0;
      }
      if (type == 0) {
        //当前状态为停用，点击后执行启用
        //调用接口启用
        var msg = "确认启用？";
        var status = 1;
      }
      Dialog.confirm({
        title: "标题",
        message: msg,
      })
        .then(() => {
          // on confirm
          if(this.nav_name=='加油卡操作'){
            this.enableCustCard(id, status);
          }else{
            this.enableCarCard(id,status)
          }
        })
        .catch(() => {
          // on cancel
        });
    },
    enableCustCard(id, status) {
      var data = {
        id: id,
        status: status,
        token: this.$storage.get("token"),
      };
      this.$api.post("orgapp/enableCustCard", data, (response) => {
        if (response.status >= 200 && response.status < 300) {
          console.log(response.data);
          var data = response.data;
          if (data.msg == "success") {
            Toast.success("更改成功！");
            this.$router.go(-1);
          }
        }
      });
    },
    enableCarCard(id,status){
        var data = {
            id:id,
            status:status,
            token:this.$storage.get('token')
        }
        this.$api.post('orgapp/enableCarCard',data,response=>{
            if (response.status >= 200 && response.status < 300) {
                console.log(response.data);
                var data = response.data;
                if(data.msg=='success'){
                    Toast.success('更改成功！');
                    this.$router.go(-1);
                }
            }
        })
    }
  },
};
</script>

<style scoped>
.main {
  background-color: #f7f8fa;
  height: 100vh;
  font-family: 'SimSun';
}
.top {
  width: 90%;
  margin: auto;
  border-radius: 5px;
  box-shadow: 5px 5px 5px #eee;
  min-height: 200px;
  background-color: #fff;
  position: relative;
}
.top_oli {
  width: 90%;
  margin: auto;
  height: 30px;
  line-height: 30px;
}
.bottom {
  padding-bottom: 20px;
  width: 90%;
  margin: auto;
  border-radius: 5px;
  box-shadow: 5px 5px 5px #eee;
  background-color: #fff;
}
.bottom_title {
  width: 65%;
  margin: auto;
  text-align: center;
}
.bottom_title span {
  font-size: 24px;
  color:#01A2E8;
  height: 40px;
  line-height: 40px;
}
.bottom_name {
  width: 100%;
  line-height: 40px;
  text-align: center;
  font-size: 26px;
}
.choose_btn {
text-align: center;
  margin: auto;
}
.fenpei_btn {
  width: 69px;
  text-align: center;
  line-height: 40px;
  height: 40px;
  color: #fff;
  border-radius: 3px;
  background-color: #eee;
  display: inline-block;
}
.fanfenpei_btn {
  width: 69px;
  text-align: center;
  line-height: 40px;
  height: 40px;
  color: #fff;
  border-radius: 3px;
  background-color: #eee;
  display: inline-block;
}
.operation_input {
  text-align: center;
  height: 50px;
  line-height: 50px;
  font-size: 16px;
}
.operation_input input {
  border: none;
  border: 1px solid #000;
  width: 140px;
  height: 30px;
  line-height: 30px;
  border-radius: 5px;
  text-align: center;
}
.determine_btn {
  animation: myAnimation 5s infinite;
  width: 57%;
  height: 40px;
  text-align: center;
  line-height: 40px;
  color: #fff;
  border-radius: 5px;
  margin: auto;
  margin-top: 15px;
  background-color: #1989FA;
  font-size: 20px;
}
@keyframes myAnimation{
  0%{
    transform: scale(1)
  }
  25%{
    transform: scale(1.2)
  }
  50%{
    transform: scale(1)
  }
  75%{
    transform: scale(1.2)
  }
}

#lv {
  color: #07c160;
  border-color: #07c160;
}
#red {
  color: #ee0a24;
  border-color: #ee0a24;
}
.lv {
  color: chartreuse;
}
.red {
  color: #fb0606;
}
#blue {
    background-color: #1989FA;
}
.operation_btn {
  width: 62px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  background-color: #1989FA;
  border-radius: 4px;
  position: absolute;
  right: 6px;
  color: #fff;
  bottom: 5px;
}
.top_title {
    text-align: center;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
}
.carNo {
    font-size: 16px;
    /* width: 48%; */
    border-bottom: 1px solid #eee;
    margin: 0;
    margin-left: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/jiayou_operation.vue